.shopping-header {
    overflow: visible;
    position: relative;

    & > img {
        opacity: 0.5;
        pointer-events: none;
        position: absolute;
        right: 0;
        top: -1rem;
        z-index: -1;
    }
}
